import {AxiosInstance} from 'axios';

export interface ProjectContextRequest {
  project_id: string;
}

export interface ProjectCreateRequest {
  name: string;
  project_state: 'open' | 'closed';
}

export interface ProjectCreateRequests {
  project_id: string;
  name: string;
  project_state: 'open' | 'closed';
}

export interface DeleteProjectRequest {
  project_id: string;
  user_id: number;
}

export type ProjectState = 'open' | 'closed';

export interface ProjectResponse {
  project_id: string;
  name: string;
  created_at: string;
  updated_at: string;
  project_owner_id: number;
  project_state: ProjectState;
}

export interface Project {
  project_id: string;
  name: string;
  project_owner_id: number;
  project_state: ProjectState;
}

export const responseToProject = (response: ProjectResponse): Project => {
  return {
    project_id: response.project_id,
    name: response.name,
    project_owner_id: response.project_owner_id,
    project_state: response.project_state,
  };
};

export const fetchProject = (http: AxiosInstance, projectId: string) => {
  return http.get(`/v1/project/${projectId}`).then(response => {
    return responseToProject(response.data);
  });
};

export const createProject = (
  http: AxiosInstance,
  request: ProjectCreateRequest
) => {
  return http
    .post('/v1/project', request)
    .then(response => {
      console.log(response.data, 'data');
      return response.data;
    })
    .catch(error => {
      console.error('Error creating project:', error);
      throw error;
    });
};

export const updateProjects = (
  http: AxiosInstance,
  request: ProjectCreateRequests
) => {
  return http
    .put(`/v1/project/${request.project_id}`, request)
    .then(response => {
      console.log(response, 'updated response');
      return response.data;
    });
};

export const fetchProjectsByOwner = (http: AxiosInstance) => {
  return http
    .get('/v1/project')
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error fetching projects by owner:', error);
      throw error;
    });
};

export const deleteProject = (
  http: AxiosInstance,
  request: DeleteProjectRequest
) => {
  return http
    .delete(`/v1/project/${request.project_id}`, {
      data: {user_id: request.user_id},
    })
    .then(response => {
      console.log(response, 'deleted response');
      return response.data;
    })
    .catch(error => {
      console.error('Error deleting project:', error);
      throw error;
    });
};

export const moveDatasetToProject = (
  http: AxiosInstance,
  projectId: string,
  datasetId: number,
  targetProjectId: string
) => {
  return http
    .put(`/v1/project/${projectId}/datasets/${datasetId}/move`, {
      target_project_id: targetProjectId,
    })
    .then(response => response.data);
};

export const setProjectContext = (projectId: string) => {
  // Update localStorage and sessionStorage
  if (projectId) {
    localStorage.setItem('project_id', projectId);
    sessionStorage.setItem('project_id', projectId);
  } else {
    localStorage.removeItem('project_id');
    sessionStorage.removeItem('project_id');
  }
};
